// extracted by mini-css-extract-plugin
export default {"path":"BA3uaJfx6PSHhbmhtwsu","object":"tWIStJHiNvBQ93ilflOE","body":"C8GxLwOZkXQ0K224wpsQ","btn":"tGVJAv8caLO3ObB0_dpb","icon":"keUn0cVF5v3dW0m0UWeS"};